import { Capacitor, CapacitorHttp } from '@capacitor/core';
import { APP_VERSION, APP_VERSION_STORE } from './version';

const headers = {
	'app-version': `${APP_VERSION_STORE}:${Capacitor.getPlatform()}:${APP_VERSION}`,
	'Content-Type': 'application/json',
};

export const httpMobileGet = async (endpoint: string, options: any) => {
	const dataSend = {
		url: `${process.env.REACT_APP_API}${endpoint}`,
		headers: {
			...headers,
			...options?.headers,
		},
		params: options?.params,
	};
	const res = await CapacitorHttp.get(dataSend);
	return res;
};

export const httpMobilePost = async (
	endpoint: string,
	data?: any,
	options?: any
) => {
	const dataSend = {
		url: `${process.env.REACT_APP_API}${endpoint}`,
		headers: {
			...headers,
			...options?.headers,
		},
		params: options?.params,
		data,
	};
	const res = await CapacitorHttp.post(dataSend);
	return res;
};

export const httpMobilePatch = async (
	endpoint: string,
	data: any,
	options: any
) => {
	const dataSend = {
		url: `${process.env.REACT_APP_API}${endpoint}`,
		headers: {
			...headers,
			...options?.headers,
		},
		params: options?.params,
		data,
	};
	const res = await CapacitorHttp.patch(dataSend);
	return res;
};
